export const FOLDER_NAME = 'SecurityCenter';
export const CONFIG_FILE_NAME = 'SecurityCenterConfig.json';

export const CONTEXT = 'Security Center page';
export const CATEGORY = 'Security Center Interaction';
